import { paymentTypes } from 'constants/campaignConstants';

const commonConfig = {
  defaultPath: '/',
  fontFamily: `'Roboto', sans-serif`,
  borderRadius: 12,
  outlinedFilled: true,
  theme: 'light',
  presetColor: 'default',
  i18n: 'en',
  defaultCampaignDuration: null,
  defaultCampaignPaymentType: paymentTypes.MONTHLY_SUBSCRIPTION,
  annualDiscountPercent: 25,
  maxImageSize: '10485760',
  googleMapsApiKey: 'AIzaSyBTomgHgMgBXgAcMqpaDJdouwNQaXD1f8Y',
};

const prodConfig = {
  basename: '/prod',
  apiBaseUrl: 'https://myygj8wp5b.execute-api.us-east-1.amazonaws.com/prod/',
  cognito: {
    REGION: 'us-east-1',
    USER_POOL_ID: 'us-east-1_hrkCEFmmM',
    APP_CLIENT_ID: '4cebnbhf0ldrc0j9a9tmueserm',
  },
};

const QAConfig = {
  basename: '/qa',
  apiBaseUrl: 'https://myygj8wp5b.execute-api.us-east-1.amazonaws.com/qa/',
  cognito: {
    REGION: 'us-east-1',
    USER_POOL_ID: 'us-east-1_k23bLOS2R',
    APP_CLIENT_ID: '7s2fg6mvnshp45s3sffpa13g0e',
  },
};

const devConfig = {
  basename: '/stage',
  apiBaseUrl: 'https://myygj8wp5b.execute-api.us-east-1.amazonaws.com/stage/',
  cognito: {
    REGION: 'us-east-1',
    USER_POOL_ID: 'us-east-1_2VN6zOZVe',
    APP_CLIENT_ID: '3e1sp66cgskv4jabes565nmppg',
  },
};

let config;

switch (process.env.REACT_APP_ENV) {
  case 'prod':
    config = prodConfig;
    break;
  case 'qa':
    config = QAConfig;
    break;
  default:
    config = devConfig;
    break;
}

export default { ...commonConfig, ...config };
